import { Calendar } from "@gravity-ui/icons";
import { Card, Flex, Icon, Text, Tooltip } from "@gravity-ui/uikit";
import moment from "moment";
import { useCallback } from "react";
import { buildImageUrl } from "src/util";

import { ProductTableData } from "../../store/fetchers";
import { SourcesCell } from "../ProductsTable/components";
import css from "./ProductCard.module.scss";

interface ProductCardProps {
  product: ProductTableData;
  onClick?: (product: ProductTableData) => void;
}

export const ProductCard = ({ product, onClick }: ProductCardProps) => {
  const handleOnClick = useCallback(() => {
    onClick?.(product);
  }, [onClick, product]);

  return (
    <div onClick={handleOnClick}>
      <Card className={css.card} view="raised">
        <div className={css.dateCaption}>
          <Icon size={10} data={Calendar} />
          <span>{moment(Date.now()).format("DD.MM.YY")}</span>
        </div>
        <Flex direction="column" gap="2" style={{ marginTop: 6 }}>
          <img
            src={buildImageUrl(product.logoUrl, {
              width: 132,
              height: 80,
              format: "webp",
            })}
            height={80}
            style={{ borderRadius: "6px" }}
          />

          <Tooltip content={product.name} openDelay={200}>
            <Text variant="body-1" ellipsis ellipsisLines={2}>
              {product.name}
            </Text>
          </Tooltip>

          <SourcesCell sources={product.sources} />
        </Flex>
      </Card>
    </div>
  );
};
